import { render, staticRenderFns } from "./MainArticleForm.vue?vue&type=template&id=0ccd4433&scoped=true&"
import script from "./MainArticleForm.vue?vue&type=script&lang=js&"
export * from "./MainArticleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd4433",
  null
  
)

export default component.exports